var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "white",
    stroke: "#ECECEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.673 9.65983L12.3328 9.0001C12.701 8.63191 12.701 8.03496 12.3328 7.66677C11.9646 7.29858 11.3676 7.29858 10.9994 7.66677L10.3323 8.33386C10.6566 8.88179 11.1179 9.33961 11.673 9.65983ZM11.3085 10.0243C10.7661 9.68808 10.3084 9.23354 9.96875 8.69744L8.07498 10.5912C7.76359 10.9026 7.60789 11.0583 7.49113 11.2406C7.43472 11.3286 7.3853 11.4209 7.34333 11.5167C7.25645 11.715 7.21327 11.9309 7.12691 12.3627C7.07863 12.6041 7.05449 12.7248 7.10158 12.8064C7.12353 12.8444 7.15512 12.876 7.19317 12.8979C7.27476 12.945 7.39545 12.9209 7.63682 12.8726L7.63683 12.8726C8.06865 12.7863 8.28455 12.7431 8.48281 12.6562C8.57858 12.6142 8.67092 12.5648 8.75897 12.5084C8.94123 12.3916 9.09692 12.2359 9.40831 11.9246L11.3085 10.0243Z",
    fill: "#EB662B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleEdit);
export default __webpack_public_path__ + "static/media/circle-edit.df5dc27801740cc76eba02f518cf7d99.svg";
export { ForwardRef as ReactComponent };